module.exports = __webpack_public_path__ + "static/img/ce.43a6858.png";


//////////////////
// WEBPACK FOOTER
// ./static/ce.png
// module id = YBv1
// module chunks = 1